module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "full"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("./img/Logo@2x.png")
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "logo_span"
  }, [_vm._v("Delauney")]), _vm._v(" "), _c('div', {
    staticClass: "full"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "box-card"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step == 1),
      expression: "step == 1"
    }],
    staticClass: "login_div"
  }, [_c('span', {
    staticClass: "login_span"
  }, [_vm._v("Create an account")]), _vm._v(" "), _c('el-form', {
    ref: "userForm",
    attrs: {
      "model": _vm.userForm,
      "rules": _vm.userRules,
      "hide-required-asterisk": true
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticClass: "registerEn",
    attrs: {
      "prop": "FirstName",
      "label": "First name"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "First name"
    },
    model: {
      value: (_vm.userForm.FirstName),
      callback: function($$v) {
        _vm.$set(_vm.userForm, "FirstName", $$v)
      },
      expression: "userForm.FirstName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticClass: "registerEn",
    attrs: {
      "prop": "LastName",
      "label": "Last name"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "Last name"
    },
    model: {
      value: (_vm.userForm.LastName),
      callback: function($$v) {
        _vm.$set(_vm.userForm, "LastName", $$v)
      },
      expression: "userForm.LastName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    staticClass: "registerEn",
    attrs: {
      "prop": "CompanyName",
      "label": "Company name"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "Company name"
    },
    model: {
      value: (_vm.userForm.CompanyName),
      callback: function($$v) {
        _vm.$set(_vm.userForm, "CompanyName", $$v)
      },
      expression: "userForm.CompanyName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    staticClass: "registerEn",
    attrs: {
      "prop": "Email",
      "label": "Email"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "Email address"
    },
    on: {
      "input": _vm.validateEmail
    },
    model: {
      value: (_vm.userForm.Email),
      callback: function($$v) {
        _vm.$set(_vm.userForm, "Email", $$v)
      },
      expression: "userForm.Email"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    staticClass: "registerEn",
    attrs: {
      "prop": "Password",
      "label": "Password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "Password",
      "show-password": ""
    },
    on: {
      "input": _vm.validatePassword
    },
    model: {
      value: (_vm.userForm.Password),
      callback: function($$v) {
        _vm.$set(_vm.userForm, "Password", $$v)
      },
      expression: "userForm.Password"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.userForm.Password) ? _c('div', {
    staticClass: "reset_box"
  }, [_c('p', {
    class: {
      'error-text': !_vm.containsAtLeastEightCharacters,
      'true-text': _vm.containsAtLeastEightCharacters,
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.containsAtLeastEightCharacters ? "√" : "X"))]), _vm._v("\n              Contains at least 8 characters\n            ")]), _vm._v(" "), _c('p', {
    class: {
      'error-text': !_vm.containsBothLowerUpper,
      'true-text': _vm.containsBothLowerUpper,
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.containsBothLowerUpper ? "√" : "X"))]), _vm._v("\n              contains both lower (a-z) and upper case letters (A-Z)\n            ")]), _vm._v(" "), _c('p', {
    class: {
      'error-text': !_vm.containsNumberOrSymbol,
      'true-text': _vm.containsNumberOrSymbol,
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.containsNumberOrSymbol ? "√" : "X"))]), _vm._v("\n              contains at least one number (0-9) or a symbol\n            ")]), _vm._v(" "), _c('p', {
    class: {
      'error-text': !_vm.doesNotContainEmail,
      'true-text': _vm.doesNotContainEmail,
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.doesNotContainEmail ? "√" : "X"))]), _vm._v("\n              Does not contain your Email address\n            ")])]) : _vm._e(), _vm._v(" "), _c('el-button', {
    staticClass: "login_submit",
    attrs: {
      "type": "danger"
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.nextStep(1)
      }
    }
  }, [_vm._v("CONTINUE")])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step == 2),
      expression: "step == 2"
    }],
    staticClass: "code_div"
  }, [_c('div', {
    staticClass: "top"
  }, [_c('span', {
    staticClass: "backup",
    on: {
      "click": _vm.preStep
    }
  }, [_vm._v("←")]), _vm._v(" "), _c('span', {
    staticClass: "login_span"
  }, [_vm._v("Verify your identity")])]), _vm._v(" "), _c('div', {
    staticClass: "sub_desc"
  }, [_c('span', {
    staticClass: "tip"
  }, [_vm._v("Enter the code we've sent to")]), _vm._v(" "), _c('span', {
    staticClass: "Email"
  }, [_vm._v(_vm._s(_vm.userForm.Email))])]), _vm._v(" "), _c('el-form', {
    ref: "codeForm",
    attrs: {
      "model": _vm.codeForm,
      "rules": _vm.codeRules
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', {
    staticClass: "registerEn",
    attrs: {
      "prop": "verificationCode",
      "label": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "code"
    },
    model: {
      value: (_vm.codeForm.verificationCode),
      callback: function($$v) {
        _vm.$set(_vm.codeForm, "verificationCode", $$v)
      },
      expression: "codeForm.verificationCode"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "no_see"
  }, [_c('span', {
    staticClass: "not_see"
  }, [_vm._v("Don't see it? ")]), _vm._v(" "), _c('span', {
    staticClass: "resend"
  }, [_c('el-button', {
    staticClass: "el_reg resend",
    attrs: {
      "type": "button",
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.smsCode
    }
  }, [(_vm.time) ? _c('span', [_vm._v(_vm._s(_vm.time) + "s later ")]) : _vm._e(), _vm._v("Resend code\n            ")])], 1)])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step == 3),
      expression: "step == 3"
    }],
    staticClass: "success_box"
  }, [_c('div', {
    staticClass: "success"
  }, [_vm._v("🥳 Success!")]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("\n          Congratulations, your account has been successfully created.\n        ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://www.delauney.ltd/pc_index",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "fwgw"
  }, [_vm._v("Visit official website →")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-911a5e74"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/RegisterEn.vue
// module id = 1764
// module chunks = 9